import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Privacy from "./pages/Privacy";
import TermsConditions from "./pages/TermsConditions";
import NotFound from "./pages/NotFound";

function App() {
  return (
    <Router className="App ">
      <Routes>
        <Route path="/" exact element={<Home />} />
        <Route path="/privacy" exact element={<Privacy />} />
        <Route path="/tnc" exact element={<TermsConditions />} />
        <Route path="*" exact element={<NotFound />} />
      </Routes>
    </Router>    
  );
}

export default App;
